import { DateTime } from 'luxon';

/**
 * Convert object keys to PascalCase for dynamic API payloads.
 * Preserves existing ReservationService.parseGenericParams behavior.
 */
export function parseGenericParams(
  params: any,
  skipArray = false,
  skipObject = false
): any {
  const parsedParams: any = {};
  for (const p in params) {
    const camelCaseProp = p.charAt(0).toUpperCase() + p.slice(1);
    if (skipArray && Array.isArray(params[p])) {
      (parsedParams as any)[camelCaseProp] = [];
      continue;
    }
    if (skipObject && params[p] === 'object') {
      if (!(params[p] instanceof DateTime || params[p] instanceof Date)) {
        (parsedParams as any)[camelCaseProp] = {};
        continue;
      }
    }
    if (params[p] !== '' && params[p] != null) {
      (parsedParams as any)[camelCaseProp] = params[p];
    }
  }
  return parsedParams;
}

/**
 * Format total minutes as "Xh Ym".
 * Preserves existing ReservationService.toHoursAndMinutes behavior.
 */
export function toHoursAndMinutes(totalMinutes: number | undefined): string {
  if (!totalMinutes && totalMinutes !== 0) return '';
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h ${minutes}m`;
}
